/*
 * Builds the url a /discount/CODE hit should land on.
 *
 * Superfiliate (like Shopify) builds affiliate links as
 * /discount/CODE?redirect=/products/handle&utm_content=xyz, so the code is
 * forwarded as `discount_code` — `useCartAddDiscountUrl` applies it to the cart
 * and therefore to checkout — the visitor is sent to the `redirect` destination
 * and every other param, utms included, is preserved.
 * @see https://help.superfiliate.com/articles/2185449010-using-superfiliate-with-headless-storefront
 */
export const getDiscountRedirectUrl = ({ code, search = '', origin }) => {
  const linkParams = new URLSearchParams(search);
  const redirect = linkParams.get('redirect');

  linkParams.delete('redirect');

  // only same origin destinations are honored, anything else falls back to home
  let destination;
  try {
    destination = new URL(redirect || '/', origin);
    if (destination.origin !== origin) destination = new URL('/', origin);
  } catch (error) {
    destination = new URL('/', origin);
  }

  // params on the affiliate link win over the destination's own params
  linkParams.forEach((value, key) => {
    destination.searchParams.set(key, value);
  });

  if (code) destination.searchParams.set('discount_code', code);

  return `${destination.pathname}${destination.search}${destination.hash}`;
};
